import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_FAULT_TICKET_ROUTER } from "../../../services/api-config";

/**
 * SLA riêng theo khách hàng — ghi đè số GIỜ của một mốc SLA (`fault-sla-config.ts`) cho một khách cụ thể.
 * Mốc không có trong danh sách override = khách đang dùng mốc CHUNG (Cài đặt hệ thống → Mốc phạt tự động).
 * Chỉ override giờ; điểm phạt/bộ phận chịu trách nhiệm vẫn theo cấu hình chung (BE order service).
 */
export interface CustomerSlaOverride {
  milestone_code: string;
  hours: number;
}

const CustomerSlaOverrideService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<CustomerSlaOverride[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (customerId: number) =>
        request({
          endPoint: API_FAULT_TICKET_ROUTER.API_CUSTOMER_SLA_OVERRIDES,
          data: { customer_id: customerId },
        }),
      response: baseResponse,
      loading,
    };
  },
  save: () => {
    const { request, baseResponse, loading } = useFetchData.Post<CustomerSlaOverride[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (customerId: number, overrides: CustomerSlaOverride[]) =>
        request({
          endPoint: API_FAULT_TICKET_ROUTER.API_CUSTOMER_SLA_OVERRIDES,
          data: { customer_id: customerId, overrides },
        }),
      response: baseResponse,
      loading,
    };
  },
  /** Tra hàng loạt: khách nào trong `customerIds` đang có ít nhất 1 override active. */
  lookupHasOverride: () => {
    const { request, baseResponse, loading } = useFetchData.Post<number[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (customerIds: number[]) =>
        request({
          endPoint: API_FAULT_TICKET_ROUTER.API_CUSTOMER_SLA_OVERRIDES_LOOKUP,
          data: { customer_ids: customerIds },
        }),
      response: baseResponse,
      loading,
    };
  },
};

export default CustomerSlaOverrideService;
